import React from "react";
import _ from "lodash";
import type { GeoJsonObject } from "geojson";
import "../shared/Heatmap.css";
import MapGeoJsonBoundaryLayer from "../../../../../components/customs/map/MapGeoJsonBoundaryLayer";
import MapSurface from "../../../../../components/customs/map/MapSurface";
import MapViewportController from "../../../../../components/customs/map/MapViewportController";
import EventClusterMarkers from "./EventClusterMarkers";
import type { LiveEventAreaModel, LiveEventModel } from "../../../types/LiveEvent";
import type { EventStatus } from "../../../types/Filter";
import { matchesLiveEventStatusFilter } from "../../../utils/live-event-status";
import {
  DEFAULT_ORGANIZATION_MAP_CONFIG,
  type OrganizationMapConfig,
} from "../../../commons/Constant";

type LiveEventsMapProps = {
  areas: LiveEventAreaModel[] | null;
  eventStatus?: EventStatus;
  filterRevision?: number;
  mapConfig?: OrganizationMapConfig;
  boundary?: GeoJsonObject;
  selectedNeighborhood?: LiveEventModel[] | null;
  onSelectNeighborhood?: (neighborhood: LiveEventModel[] | null) => void;
  onSelectEvent?: (event: LiveEventModel | null) => void;
};

const LiveEventsMap: React.FC<LiveEventsMapProps> = ({
  areas: liveEvents,
  eventStatus,
  filterRevision,
  mapConfig = DEFAULT_ORGANIZATION_MAP_CONFIG,
  boundary,
  selectedNeighborhood,
  onSelectEvent,
  onSelectNeighborhood,
}) => {
  const liveEventWithFilter = () => {
    if (_.isNil(eventStatus)) return liveEvents;

    return liveEvents?.map((liveEvent) => ({
      ...liveEvent,
      live_events: liveEvent.live_events?.filter((event) => matchesLiveEventStatusFilter(event, eventStatus)),
    }));
  };

  return (
    <div className="h-full w-full p-4">
      <MapSurface
        initialViewport={{ center: mapConfig.center, zoom: mapConfig.zoom }}
        style={{
          height: "100%",
          width: "100%",
          fontFamily: "Nunito, sans-serif",
          borderRadius: "1rem",
        }}
        minZoom={10} // prevent zooming out too far beyond Saginaw area
        maxZoom={18} // optional: prevent zooming in too close
        className="rounded-2xl overflow-hidden"
      >
        <MapViewportController
          viewport={{ center: mapConfig.center, zoom: mapConfig.zoom }}
          revision={filterRevision}
          transition="set"
        />
        <MapGeoJsonBoundaryLayer data={boundary ?? mapConfig.boundary} />
        <EventClusterMarkers
          liveEvents={liveEventWithFilter() || []}
          selectedNeighborhood={selectedNeighborhood}
          onSelectNeighborhood={onSelectNeighborhood}
          onSelectEvent={onSelectEvent}
        />
      </MapSurface>
    </div>
  );
};

export default LiveEventsMap;
